import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, scale, fill, spacing, rotation, gradient, verticalOffset }) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  const leftTransformOrigin = '7.8804 10.8087'
  const rightTransformOrigin = '44.2876 10.8087'

  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g
        transform={`translate(${-spacing}) rotate(${rotation}) scale(${scale},${scale})`}
        transform-origin={leftTransformOrigin}
      >
        <path
          d="M0.16237 15.8687C0.16237 15.8687 1.91757 12.9156 3.67276 11.9312C5.42795 10.9468 15.6001 11.2749 15.6001 11.2749V5.36865C15.6001 5.36865 6.22577 5.97519 3.49326 6.68116C-1.11412 7.87434 0.16237 15.8687 0.16237 15.8687Z"
          fill={`url(#${randomGradientId1})`}
        />
        <path
          d="M0.130372 10.8087C0.130372 10.8087 1.89264 7.85563 3.65491 6.87125C5.41718 5.88688 15.6304 6.21497 15.6304 6.21497V0.308716C15.6304 0.308716 5.94788 0.308723 3.47468 1.62122C1.01151 2.92378 0.130372 10.8087 0.130372 10.8087Z"
          fill={fill}
        />
      </g>
      <g
        transform={`translate(${spacing}) rotate(${-rotation}) scale(${scale},${scale})`}
        transform-origin={rightTransformOrigin}
      >
        <path
          d="M52.0376 10.8087C52.0376 10.8087 50.2753 7.85563 48.5131 6.87125C46.7508 5.88688 36.5376 6.21497 36.5376 6.21497V0.308716C36.5376 0.308716 46.2201 0.308723 48.6933 1.62122C51.1565 2.92378 52.0376 10.8087 52.0376 10.8087Z"
          fill={fill}
        />
        <path
          d="M52.0056 15.8687C52.0056 15.8687 50.2504 12.9156 48.4952 11.9312C46.74 10.9468 36.5679 11.2749 36.5679 11.2749V5.36865C36.5679 5.36865 45.9422 5.97519 48.6747 6.68116C53.2821 7.87434 52.0056 15.8687 52.0056 15.8687Z"
          fill={`url(#${randomGradientId2})`}
        />

        <defs>
          <linearGradient
            id={randomGradientId1}
            x1="44.368"
            y1="17.6845"
            x2="44.368"
            y2="8.14274"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.2877" stopColor={gradient[1]} stopOpacity="0" />
            <stop offset="0.8775" stopColor={gradient[0]} stopOpacity=".25" />
          </linearGradient>
          <linearGradient
            id={randomGradientId2}
            x1="7.80001"
            y1="17.6845"
            x2="7.80001"
            y2="8.14274"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.2877" stopColor={gradient[1]} stopOpacity="0" />
            <stop offset="0.8775" stopColor={gradient[0]} stopOpacity=".25" />
          </linearGradient>
        </defs>
      </g>
    </g>
  )
}
